import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Message } from "../../../@types/message";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";
export const findUserMessages = createAsyncThunk(
  "user/findUserMessages",
  async (id: number, { rejectWithValue, getState }) => {
    const state = getState() as RootState;

    try {
      const { data } = await axiosInstance.get(`${api.baseURL}message`, {
        params: {
          where: {
            createdBy: id,
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          },
          sort: "createdAt DESC",
        },
      });
      return data as Message[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
